const e = (t) => Object.keys(t).length === 0, r = (t) => t.length === 0;
export {
  r as isEmptyArray,
  e as isEmptyObject
};
